import { topSidePartOfWeb } from './parts/sideParts'

export const type22Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.7
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // ウェブ本体
  ctx.beginPath()
  ctx.moveTo(300, 376) // 左下
  ctx.quadraticCurveTo(339, 334, 373, 252) // 右下
  ctx.quadraticCurveTo(384, 159, 359, 92) // 右上
  ctx.quadraticCurveTo(269, 153, 210, 260) // 左上
  ctx.quadraticCurveTo(300, 376, 300, 376) // 左下
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.lineWidth = 0.8
  ctx.setLineDash([3, 3])
  ctx.strokeStyle = stitchColor
  ctx.moveTo(329, 134) // 左上＿左上
  ctx.lineTo(346, 168) //左上＿右下
  ctx.quadraticCurveTo(336, 173, 342, 221)
  ctx.quadraticCurveTo(350, 250, 335, 273) // 右下
  ctx.quadraticCurveTo(343, 230, 316, 244)
  ctx.lineTo(316, 254)
  ctx.lineTo(324, 247)
  ctx.quadraticCurveTo(320, 259, 319, 290) // 中央下
  ctx.quadraticCurveTo(311, 269, 306, 271)
  ctx.quadraticCurveTo(310, 261, 307, 248)
  ctx.lineTo(299, 254)
  ctx.quadraticCurveTo(301, 279, 308, 275)
  ctx.quadraticCurveTo(306, 308, 294, 321)
  ctx.quadraticCurveTo(301, 288, 293, 259)
  ctx.quadraticCurveTo(263, 277, 282, 330)
  ctx.quadraticCurveTo(285, 340, 293, 339)
  ctx.quadraticCurveTo(305, 333, 296, 321)
  ctx.quadraticCurveTo(308, 327, 320, 320)
  ctx.quadraticCurveTo(301, 353, 292, 354)

  ctx.moveTo(270, 321) // 左上親指側面から上に
  ctx.quadraticCurveTo(270, 298, 258, 301) // 左上
  ctx.quadraticCurveTo(261, 273, 283, 235)
  ctx.quadraticCurveTo(280, 257, 280, 259)
  ctx.lineTo(292, 249)
  ctx.quadraticCurveTo(293, 242, 288, 241)
  ctx.quadraticCurveTo(294, 226, 296, 210)
  ctx.quadraticCurveTo(295, 233, 301, 235)
  ctx.quadraticCurveTo(294, 244, 301, 242)
  ctx.lineTo(306, 237)
  ctx.quadraticCurveTo(307, 218, 300, 218)
  ctx.quadraticCurveTo(303, 200, 295, 196)
  ctx.quadraticCurveTo(290, 193, 300, 193) // 中央頂点
  ctx.quadraticCurveTo(316, 189, 312, 231)
  ctx.quadraticCurveTo(338, 219, 329, 178)
  ctx.quadraticCurveTo(326, 149, 326, 149)
  ctx.quadraticCurveTo(325, 134, 329, 134)

  // 外輪郭
  ctx.moveTo(349, 107) //右上
  ctx.quadraticCurveTo(365, 233, 365, 233) // 右下
  ctx.quadraticCurveTo(368, 252, 358, 277) // 中央右下
  ctx.moveTo(295, 362) //左下
  ctx.quadraticCurveTo(300, 367, 316, 342) // 中央左下
  ctx.moveTo(232, 264) //左上
  ctx.quadraticCurveTo(265, 172, 348, 112) // 右上

  // 内輪郭
  ctx.moveTo(346, 107) //右上
  ctx.quadraticCurveTo(362, 233, 362, 233) // 右下
  ctx.quadraticCurveTo(365, 252, 355, 275) // 中央右下
  ctx.moveTo(296, 358) //左下
  ctx.quadraticCurveTo(300, 363, 316, 342) // 中央左下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)
}
